export default __webpack_public_path__ + "static/media/element_19.eb254cc9.webp";